import AnimatedMap from '../components/Contacts/Map'
import { useEffect } from 'react'

export default function ContactsPage() {
  useEffect(() => {
    document.title = 'Turtton - Контакты'
  }, [])

  return (
    <div className='relative w-full bg-white pt-20 lg:pt-28'>
      <div className='w-[94%] lg:w-[80%] mx-auto relative'>
        <h1 className='text-xl lg:text-3xl 2xl:text-[40px] text-[#273167] font-bold mt-4 2xl:mt-7'>
          Наши контакты
        </h1>
        <div className='mt-4 mb-8 lg:mb-32 lg:mt-8 2xl:mt-12 flex flex-col gap-8 lg:gap-0 lg:justify-between lg:flex-row 2xl:mb-32'>
          <div className='w-full lg:w-[43%] mt-6 lg:mt-6'>
            <div className='w-full grid grid-cols-2 gap-3 lg:gap-12 2xl:gap-16'>
              <div className='flex'>
                <img
                  src='/icon-contacts/time.webp'
                  alt=''
                  className='h-4 lg:h-7 2xl:h-8 mr-1 lg:mr-3'
                />
                <div>
                  <p className='text-[#60636F] text-[9px] lg:text-base 2xl:text-lg lg:mb-0.5 font-medium'>
                    График работы:
                  </p>
                  <p className='text-[#273167] text-xs lg:text-lg 2xl:text-2xl font-medium'>
                    ПН-ПТ: 10:00-19:00 <br /> СБ-ВС:{' '}
                    <span className='text-[#FF1616]'>Выходной</span>
                  </p>
                </div>
              </div>
              <div className='flex justify-end'>
                <img
                  src='/icon-contacts/number.webp'
                  alt=''
                  className='h-4 lg:h-7 2xl:h-8 mr-1 lg:mr-3'
                />
                <div>
                  <p className='text-[#60636F] text-[9px] lg:text-base 2xl:text-lg lg:mb-0.5 font-medium'>
                    Телефон для связи:
                  </p>
                  <a
                    href='tel:+79524030253'
                    className='text-[#273167] text-xs lg:text-lg 2xl:text-2xl font-medium hover:underline'
                  >
                    +7(952)-403-02-53
                  </a>
                </div>
              </div>
              <div className='flex'>
                <img
                  src='/icon-contacts/loc.webp'
                  alt=''
                  className='h-4 lg:h-7 2xl:h-8 mr-1 lg:mr-3'
                />
                <div>
                  <p className='text-[#60636F] text-[9px] lg:text-base 2xl:text-lg lg:mb-0.5 font-medium'>
                    Адрес:
                  </p>
                  <a
                    href='https://yandex.ru/maps/-/CHASRQM9'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-[#273167] text-xs lg:text-lg 2xl:text-2xl font-medium hover:underline'
                  >
                    г.Ижевск,
                    <br /> ул. Холмогорова, д. 43
                  </a>
                </div>
              </div>
              <div className='flex justify-end'>
                <img
                  src='/icon-contacts/mail.webp'
                  alt=''
                  className='h-4 lg:h-7 2xl:h-8 mr-1 lg:mr-3'
                />
                <div>
                  <p className='text-[#60636F] text-[9px] lg:text-base 2xl:text-lg lg:mb-0.5 font-medium'>
                    Email:
                  </p>
                  <a
                    href='mailto:turtton@yandex.ru'
                    className='text-[#273167] text-xs lg:text-lg 2xl:text-2xl font-medium hover:underline'
                  >
                    turtton@yandex.ru
                  </a>
                </div>
              </div>
            </div>
            <div className='mt-6 lg:mt-16 2xl:mt-24 flex'>
              <img
                src='/icon-contacts/file.webp'
                alt=''
                className='h-4 lg:h-7 2xl:h-8 mr-1 lg:mr-3'
              />
              <a
                href='/turtton-info.pdf'
                target='_blank'
                rel='noopener noreferrer'
                className='text-[#273167] text-xs lg:text-lg 2xl:text-2xl font-medium underline underline-offset-4'
              >
                Карточка предприятия
              </a>
            </div>
          </div>
          <AnimatedMap />
        </div>
      </div>
    </div>
  )
}
